module.exports = __webpack_public_path__ + "static/media/404-sicherheit.ab94a926.png";